import API from 'core/api'

export default {

	namespaced: true,

	modules: {},

	state: {},

	getters: {},

	mutations: {},

	actions: {

		csv: function(context, params) {

			return new Promise(function(resolve, reject) {

				API.request('export/csv', params).then(function(json) {

					resolve(json)

				}, function(json) {

					reject(json)

				})

			})

		},

		clipboard: function(context, params) {

			return new Promise(function(resolve, reject) {

				API.request('export/clipboard', params).then(function(json) {

					resolve(json)

				}, function(json) {

					reject(json)

				})

			})

		}
		
	}

}